import { Component } from '@angular/core';
import { ModalService } from '@app/shared/services/helpers/modal/modal.service';
import { IconsDefinitionHelper } from '@shared/common/definition-helper';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'app-global-search-bar',
    templateUrl: './global-search-bar.component.html',
    styleUrls: ['./global-search-bar.component.scss'],
    standalone: true,
    imports: [IconComponent]
})
export class GlobalSearchBarComponent extends IconsDefinitionHelper{

  constructor(
    private modalService: ModalService,
  ) {
    super();
  }

  public async openSearchModal(value?: string): Promise<void> {
    // eslint-disable-next-line max-len
    const {GlobalSearchBarModalComponent} = await import('@app/clinician-dashboard/modals/global-search-bar-modal/global-search-bar-modal.component');
    const modalData = {placeholder: value};
    this.modalService.open(GlobalSearchBarModalComponent, modalData);
  }

}
